import React, { createContext, useContext } from 'react';

const LayoutContext = createContext();

export const LAYOUT_VERSIONS = {
  ORIGINAL: 'original'
};

export const LayoutProvider = ({ children }) => {
  const contextValue = {
    currentLayout: LAYOUT_VERSIONS.ORIGINAL,
    switchLayout: () => {},
    getCurrentLayoutConfig: () => ({ id: 'original', name: 'Original', description: 'Layout original' }),
    getAllLayoutConfigs: () => [{ id: 'original', name: 'Original', description: 'Layout original' }],
    isTransitioning: false,
    LAYOUT_VERSIONS
  };

  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout deve ser usado dentro de um LayoutProvider');
  }
  return context;
};

export default LayoutContext;